import { render, staticRenderFns } from "./AccountComponentPayment.vue?vue&type=template&id=4ff30094"
import script from "./AccountComponentPayment.vue?vue&type=script&lang=js"
export * from "./AccountComponentPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports